import { useRouter } from 'next/router';
import { Cell, Legend, Pie, PieChart, Tooltip } from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const MethodologyGender: React.FC = () => {
  const { locale } = useRouter();

  const dataEN = [
    { name: 'Women', value: 13.436102388428965 },
    { name: 'Men', value: 77.26710438671614 },
    { name: 'Unknown', value: 8.583119231135218 }
  ];

  const dataES = [
    { name: 'Mujeres', value: 13.436102388428965 },
    { name: 'Hombres', value: 77.26710438671614 },
    { name: 'Indeterminado', value: 8.583119231135218 }
  ];

  const data = locale === 'es' ? dataES : dataEN;

  return (
    <div>
      <StyledRecharts className="methodology gender">
        <PieChart width={370} height={220}>
          <Legend
            layout="horizontal"
            verticalAlign="bottom"
            iconType="square"
          />
          <Tooltip
            cursor={{ fill: 'transparent' }}
            labelStyle={{ display: 'none' }}
            separator=": "
            formatter={(value: number) => value.toFixed(1) + '%'}
            wrapperClassName="tooltip-y"
          />
          <Pie data={data} dataKey="value">
            <Cell fill="#746FB3" />
            <Cell fill="#1B9D76" />
          </Pie>
        </PieChart>
      </StyledRecharts>
    </div>
  );
};

export default MethodologyGender;
